import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogService } from 'ng2-bootstrap-modal';
import { Observable } from 'rxjs/Rx';
import { SMSURLLABELS } from '../_constants/constants';


@Component({
  templateUrl: './smsclose.component.html'
})

export class SmscloseComponent{
  smsurllabels = SMSURLLABELS;
 
  constructor(private router: Router, private ds: DialogService, private route: ActivatedRoute) {
  	
  }

  ngOnInit(): void {

  }
}



// WEBPACK FOOTER //
// ./src/app/smsurl/smsclose.component.ts